<div class="container error-state" role="alert">
  <div class="error-state__icon" aria-hidden="true">⚠️</div>
  <h3 class="error-state__title">{{ error.message | translate }}</h3>
  <p class="error-state__details">{{ 'ERRORS.TRY_AGAIN_LATER' | translate }}</p>
  @if (error.retryable) {
    <button class="error-state__retry" (click)="retry.emit()">
      {{ 'COMMON.RETRY' | translate }}
    </button>
  }
</div>
